import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import { EsriMapComponent } from "src/app/esri-map/esri-map.component";
import { QueryBuilderService } from "src/app/services/query-builder.service";
import { QueryBuilderConstants } from "src/app/query-builder/query-builder-constants";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";
import * as deepEqual from "deep-equal";
import { AssetAttributesService } from "src/app/services/asset-attributes.service";
import { GenericLayerService } from "src/app/services/generic-layer.service";
import { QueryLayersService } from "src/app/services/query-layers.service";
import { adminGlobal } from "src/app/admin-mmm/adminGlobal";
import { MMMAdminService } from "src/app/admin-mmm/admin-mmm.reports.service";
import { faCalendarAlt as faCalendar, faPlusSquare, faMinusSquare, faTrashAlt, faSave } from "@fortawesome/free-regular-svg-icons";
import { faPenSquare } from "@fortawesome/free-solid-svg-icons";
import { UserService } from "src/app/services/user.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgFor, NgIf } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IUser } from "src/app/interface/user";
import { IQueryStatement } from "src/app/interface/other";
import { ILayerDropdownListItem } from "src/app/interface/DropDownListItem";

@Component({
    selector: "sms-MMMQuery",
    templateUrl: "./MMMQuery.component.html",
    styleUrls: ["../../administrator.component.scss"],
    standalone: true,
    imports: [FormsModule, NgFor, NgIf, MatFormFieldModule, MatInputModule, MatDatepickerModule, FontAwesomeModule]
})
export class MMMQueryComponent implements OnInit {
  constructor(
    public authenticationService: AuthenticationService,
    public esriMapTool: EsriMapComponent,
    public qbService: QueryBuilderService,
    public translateService: TranslateService,
    public assetAttributesService: AssetAttributesService,
    public constants: QueryBuilderConstants,
    public genericLayerService: GenericLayerService,
    public queryLayersService: QueryLayersService,
    public adminGlobalobj: adminGlobal,
    public adminService: MMMAdminService,
    public userService: UserService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }
  faPlusSquare = faPlusSquare;
  faPencilSquare = faPenSquare;
  faCalendar = faCalendar;
  faTrash = faTrashAlt;
  trash = faTrashAlt;
  faSave = faSave;
  faMinusSquare = faMinusSquare;

  public currentUser: IUser;
  isResultPresent: boolean;
  public todayDate: Date = new Date();
  public savedQueriesList: any;
  public layersfields: any[] = [];

  public inventoryLayersData: any;
 
  public joinTypes: any[] = [];
  public joinType: any;
  public dropdownLayerList: ILayerDropdownListItem[] = [];
  public layr: ILayerDropdownListItem = {} as ILayerDropdownListItem;
  public selectedLayer: ILayerDropdownListItem | null = null;
  public lyrfld: any;
  public field: any[] = [];
  public selectedFieldName: any;
  public operators: any[] = [];
  public codedValues: any[] = [];
  public codedvalue: any;

  public showRecordCount = false;
  public slData = [];
  public selectedLoadFile: string;
  public builtQuery: IQueryStatement[] = [];
  public queryStatement: IQueryStatement = {} as IQueryStatement;

  public fileName: any;



  public operator: any;
  public enableDateTimePicker: any;


  public index: any;
  public isRowClicked: boolean;

  public selectionGraphicsLyr: any;
  public queryDataObj = [];
  @Output() data = new EventEmitter();

  public multiplePrimaryLayerQuery: any;
  public objectIds: any[] = [];
  public loading = false;
  public multipleResults = false;

  public multipleResultCounts = [];

  /** Save from query table to database */
  public queryDescription: string;

  public queryAssigned: any = "PQ-A";


  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  ngOnInit() {
    // All Layers Data
    this.assetAttributesService.getTableAlias().subscribe( (result: any) => {
        this.slData = result.features;
        this.loadLayers().then((ldataresult) => {
          this.inventoryLayersData = ldataresult;
          console.log(this.inventoryLayersData);
          this.savedQueriesList = this.getSavedQueries("PQ");
          this.savedQueriesList.concat(this.getSavedQueries("PQ-A"));
          this.initQBServiceVariables();
          this.dropdownLayerList = this.qbService.getLayerListDropdownValues();
          this.layr = this.dropdownLayerList[0];
          this.layr.lyrObj.fields.forEach((f) => {
            this.field.push({
              Field: f.name,
              FieldAlias: f.alias
            });
          });
          this.operators = this.constants.getOperators();
          this.joinTypes = this.constants.getJoinType();
          this.defaultDropdownValues();
        });
      }
    );
  }

  loadLayers() {
    return new Promise((resolve) => {
      try {
        const featureLayerOptions = { mode: this.esriMapTool.FeatureLayer.MODE_ONDEMAND, outFields: ["*"] };
        const inventory = [];
        this.adminService.getAllLayersInformation(this.adminGlobalobj.agencyDetails[0].webServiceUrl).subscribe((result) => {
          console.log(result);
          // allLayers eslint camel case fix
          const allLayers: any = result;
          const inventoryLayer = allLayers.layers.filter((layer) => layer.name === "Inventory")[0];
          inventoryLayer.subLayerIds.forEach((id) => {
            const temp = allLayers.layers.filter((ids) => ids.id === id);
            const flObj: any = new this.esriMapTool.FeatureLayer(this.adminGlobalobj.agencyDetails[0].webServiceUrl + environment.featureServer + id, featureLayerOptions);
            this.adminService.getDomainValuesFields(this.adminGlobalobj.agencyDetails[0].webServiceUrl, temp[0].id).subscribe((result: any) => {
              console.log(result);
              flObj.relationships = result.relationships;
              temp.layerName = temp[0].name;
              temp.lyrObj = flObj;
              // aliasValuesm eslint fix camel case
              const aliasValuesm = this.adminGlobalobj.ShowAsset.filter((val) => val.Name === temp[0].name);

              if (aliasValuesm && aliasValuesm.length > 0) {
                temp.tableAlias = aliasValuesm[0].Alias;
                temp.tableSL = aliasValuesm[0].Alias_SL;
              }

              inventory.push(temp);

              const filtered = [];
              if (inventory.length === inventoryLayer.subLayerIds.length) {
                console.log(this.adminGlobalobj.ShowAsset);
                console.log(inventory);
                this.adminGlobalobj.ShowAsset.forEach((assetClass) => {
                  filtered.push(inventory.filter((inv) => inv.layerName === assetClass.Name)[0]);
                });
              }
              resolve(filtered);
            });
          });
        });
      } catch (error) {
        console.error(error);
        resolve([]);
      }
    });
  }

  getSavedQueries(queryTool) {
    try {
      queryTool = this.queryAssigned;
      const userActionsQueryLayer = this.adminGlobalobj.agencyDetails[0].webServiceUrl + environment.featureServer + this.adminGlobalobj.serviceLyrInfo.userQueryActionsId;
      const userActionsQueryLayerObj = new this.esriMapTool.FeatureLayer(userActionsQueryLayer);
      const promise = this.qbService.getSavedQueryWithoutUser(userActionsQueryLayerObj, this.esriMapTool.Query, this.esriMapTool.QueryTask, queryTool); // Populating Default Values in New Asset
      const savedQueryNames = [];
      const savedQueryList = [];
      promise.then(
        function (result) {
          if (result) {
            savedQueryNames.push(result);
            savedQueryNames[0].features.forEach((savedQuery) => {
              if (savedQuery.attributes.QueryName != null) {
                savedQueryList.push({
                  fileName: savedQuery.attributes.QueryName,
                  queryString: savedQuery.attributes.Query,
                  queryDescription: savedQuery.attributes.QueryDescription,
                  queryTool: savedQuery.attributes.QueryTool
                });
              }
            });
          }
        }.bind(this)
      );
      return savedQueryList;
    } catch (error) {
      console.error(error);
    }
  }

  onFileNameChange(event, queryTool) {
    try {
      this.selectedLoadFile = event;
      this.populateQueryTable(this.selectedLoadFile, queryTool);
    } catch (error) {
      console.error(error);
    }
  }

  populateQueryTable(selectedFile, queryTool) {
    try {
      if (queryTool === "PQ-A" || queryTool === "PQ") {
        this.builtQuery = [];
        const queryStringSelected = this.savedQueriesList.filter((savedQuery) => savedQuery.fileName === this.selectedLoadFile);
        this.parseQuery(queryStringSelected);
        // Get Layer Name
        let layer = queryStringSelected[0].queryString.split("?")[0].split(":")[0];
        // primaryLayer eslint fix camel case
        let primaryLayer;

        if (layer === "Sign" || layer === "Light" || layer === "Maintenance" || layer === "Assessment" || layer === "Activity") {
          primaryLayer = layer;
          layer = "Support";
        }

        this.dropdownLayerList = this.qbService.getLayerListDropdownValues(layer);
        this.queryDescription = queryStringSelected[0].queryDescription;
        this.queryAssigned = queryStringSelected[0].queryTool;
      }
    } catch (error) {
      console.error(error);
    }
  }
  parseQuery(queryStringSelected) {
    this.builtQuery = [];

    try {
      const queryString = queryStringSelected[0].queryString;
      this.fileName = queryStringSelected[0].fileName;
      let queries = [];
      queries = queryString.split("?");
      const layers = queries[0].split(":");
      const clauses = queries[1].split(";");

      for (let i = 1; i < clauses.length; i++) {
        this.queryStatement = {} as IQueryStatement;
        const conditionSplit = clauses[i].trim().split(" ");

        if (conditionSplit.length === 3) {
          // tablePrefix eslint fix
          const tablePrefixM = conditionSplit[0].split(".")[0];
          this.queryStatement.layer = this.constants.getQueryTables(tablePrefixM, layers[0]);
          const fieldName = conditionSplit[0].split(".");
          this.queryStatement.field = fieldName[1];
          this.queryStatement.operator = conditionSplit[1];
          this.queryStatement.value = conditionSplit[2].replace(/'/g, "");
        } else {
          const tablePrefixM = conditionSplit[1].split(".")[0];
          this.queryStatement.layer = this.constants.getQueryTables(tablePrefixM, layers[0]);
          this.queryStatement.joinType = conditionSplit[0];
          const fieldName = conditionSplit[1].split(".");
          this.queryStatement.field = fieldName[1];
          this.queryStatement.operator = conditionSplit[2];
          this.queryStatement.value = conditionSplit[3].replace(/'/g, "");
        }

        this.builtQuery.push(Object.create(this.queryStatement));
      }
    } catch (err) {
      if (err) {
        Swal.fire("Invalid Format");
      }
    }
  }
  onJoinChange(event) {
    this.joinType = event;
  }
  onLayerChange(event) {
    try {
      this.selectedLayer = event; /** Set Selected Layer */

      if (this.selectedLayer) {
        /** Reset Fields and Values if layers is changed */
        this.selectedFieldName = "";
        this.field = [];
        this.codedValues = [];
        this.codedvalue = "";
        this.layr = this.dropdownLayerList.find((l) => l.value === this.selectedLayer?.value) as ILayerDropdownListItem;
        this.layr.lyrObj.fields.forEach((fld) => {
          this.field.push({
            Field: fld.name,
            FieldAlias: fld.alias
          });
        });
      }

      return this.field;
    } catch (error) {
      console.error(error);
      return [];   // Return an empty array in case of an error
    }
  }

  onFieldChange(event) {
    try {
      this.selectedFieldName = event;
      this.operator = "=";
      this.lyrfld = this.layr.lyrObj._fields.find((fld) => fld.name === this.selectedFieldName);
      this.codedValues = [];
      this.codedvalue = "";
      this.enableDateTimePicker = false;

      if (this.constants.userFields.includes(this.selectedFieldName)) {
        this.userService.getWorkerList(this.currentUser.clientId).subscribe( 
          (result: any) => {
            this.codedValues = result.map((worker) => {
              return {name: worker.displayName, code: worker.displayName}
            })
          },
          (error: any) => {
            this.codedValues.push({ name: this.currentUser.displayName, code: this.currentUser.displayName});
          }
        );
      }

      if (this.selectedFieldName.includes("Date")) {
        this.enableDateTimePicker = true;
      } // UC  – 20134:

      if (this.lyrfld[0] && this.lyrfld[0].domain) {
        this.codedValues = this.lyrfld[0].domain.codedValues;
      }

      if (this.selectedFieldName === "Activity") {
        // for all primary layers if only activity is selected
        const baseurl = this.adminGlobalobj.agencyDetails[0].webServiceUrl + environment.featureServer + this.adminGlobalobj.serviceLyrInfo.activityId;
        const activityLayer = new this.esriMapTool.FeatureLayer(baseurl);
        const promise = this.qbService.getActivityDomains(activityLayer);
        const activityDomainsList = [];
        promise.then((results) => {
          activityDomainsList.push(results);
          this.codedValues = activityDomainsList[0];
        });
      }

      return this.codedValues;
    } catch (error) {
      console.error(error);
    }
  }
  onValueChange(event) {
    try {
      if (event instanceof Date) {
        const month = event.getMonth();
        this.codedvalue = event.getFullYear() + "-" + (month + 1) + "-" + event.getDate();
        this.qbService.selectedDate = event;
      } else {
        this.codedvalue = event;
      }
    } catch (error) {
      console.error(error);
    }
  }
  onOperatorChange(event) {
    this.operator = event;
  }
  defaultDropdownValues() {
    try {
      this.selectedLayer = this.dropdownLayerList[0];
      this.layr = this.selectedLayer; // this.dropdownLayerList.find((l) => l.value === this.selectedLayer?.value) as ILayerDropdownListItem;
      this.selectedFieldName = this.field[0].FieldAlias;
      this.operator = "=";
    } catch (error) {
      console.error(error);
    }
  }
  initQBServiceVariables() {
    try {
      this.qbService.map = this.esriMapTool.map;
      this.qbService.Query = this.esriMapTool.Query;
      (this.qbService.QueryTask = this.esriMapTool.QueryTask), (this.qbService.RelationshipQuery = this.esriMapTool.RelationshipQuery);
      (this.qbService.inventoryLayersData = this.inventoryLayersData), (this.qbService.FeatureLayer = this.esriMapTool.FeatureLayer);
      this.qbService.aliasData = this.slData;
    } catch (error) {
      console.error(error);
    }
  }
  addItem() {
    try {
      /** Create a new row to Insert into table */
      this.queryStatement = {} as IQueryStatement;
      /** Add selected data into table row */
      this.queryStatement.field = this.selectedFieldName;
      this.queryStatement.layer = this.selectedLayer!.value;
      this.queryStatement.operator = this.operator;

      if (this.codedvalue instanceof Date) {
        const formattedDate = this.codedvalue.getMonth() + 1 + "-" + this.codedvalue.getDate() + "-" + this.codedvalue.getFullYear();
        this.queryStatement.value = formattedDate;
      } else {
        if (this.selectedFieldName === "AssetCode") {
          this.qbService.assetCode = this.codedValues;
        }

        this.queryStatement.value = this.codedvalue;
      }

      if (this.joinType) {
        this.queryStatement.joinType = this.joinType;
      } else {
        this.queryStatement.joinType = undefined;
      }

      if (this.builtQuery.length > 0 && !this.queryStatement.joinType) {
        Swal.fire("Please add join type");
        return;
      }

      if (this.queryStatement.field && this.queryStatement.layer && this.queryStatement.operator && this.queryStatement.value) {
        // Refresh DropdownList to Fetch related Tables : Neha 1/10
        if (this.queryStatement.layer !== "Activity" && this.queryStatement.layer !== "Assessment" && this.queryStatement.layer !== "Maintenance" && this.queryStatement.layer !== "Light" && this.queryStatement.layer !== "Sign") {
          //this.qbService.disableLayerDropdown(this.qbService.getLayerInfo(this.queryStatement.layer), "");
          this.dropdownLayerList = this.qbService.getLayerListDropdownValues(this.queryStatement.layer);
        }

        if (this.builtQuery.length === 1) {
          const joinTemp = this.queryStatement.joinType;
          this.queryStatement.joinType = undefined;
          //const sameQueryValidation = this.builtQuery.filter((fil) => deepEqual(this.queryStatement, fil.__proto__));
          const sameQueryValidation = this.builtQuery.filter((s: IQueryStatement) => {
            return (
              //s.jointype === this.queryStatement.jointype &&   // 9/23/26 ignore join
              s.layer === this.queryStatement.layer &&
              s.field === this.queryStatement.field &&
              s.operator === this.queryStatement.operator &&
              s.value === this.queryStatement.value
            )
          });

          if (sameQueryValidation.length >= 1) {
            Swal.fire("Query cannot be same");
            return;
          }

          this.queryStatement.joinType = joinTemp;
        } else {
          //const sameQueryValidation = this.builtQuery.filter((fil) => deepEqual(this.queryStatement, fil.__proto__));
          const sameQueryValidation = this.builtQuery.filter((s: IQueryStatement) => {
            return (
              //s.jointype === this.queryStatement.jointype &&   // 9/23/26 ignore join
              s.layer === this.queryStatement.layer &&
              s.field === this.queryStatement.field &&
              s.operator === this.queryStatement.operator &&
              s.value === this.queryStatement.value
            )
          });
          if (sameQueryValidation.length >= 1) {
            Swal.fire("Query cannot be same");
            return;
          }
        }

        // End
        this.builtQuery.push(Object.create(this.queryStatement));
        this.queryStatement = {} as IQueryStatement;

        /** Dont show Primary layers when Sign or Light is selectethis.querytable = <Querytable>{};d first */
        if (this.builtQuery.length === 1 && (this.builtQuery[0].layer === "Sign" || this.builtQuery[0].layer === "Light")) {
          //this.qbService.disableLayerDropdown(this.qbService.getLayerInfo("Support"), this.builtQuery[0].layer);
          this.dropdownLayerList = this.qbService.getLayerListDropdownValues(this.builtQuery[0].layer);
        }

        /** Dont show Primary layers or Asset Layers when Assessment, Maintenance or Activity Selected first */
        if (this.builtQuery.length === 1 && (this.builtQuery[0].layer === "Maintenance" || this.builtQuery[0].layer === "Assessment" || this.builtQuery[0].layer === "Activity")) {
          //this.qbService.disableLayerDropdown(this.qbService.getLayerInfo("Support"), this.builtQuery[0].layer);
          this.dropdownLayerList = this.qbService.getLayerListDropdownValues(this.builtQuery[0].layer);
        }
      } else {
        // Default Layers List : Neha 1/10
        //this.layerList = this.qbService.getLayerInfo();
        this.dropdownLayerList = this.qbService.getLayerListDropdownValues();
        Swal.fire("Enter all values");
      }

      // this.lyrfld[0].empty();
    } catch (error) {
      console.error(error);
    }
  }
  setClickedRow(index) {
    try {
      this.index = index;
      // Set Clicked Row
      this.isRowClicked = true;
      // Set all Drop down Values
      this.field = this.onLayerChange(this.builtQuery[index].layer);
      this.codedValues = this.onFieldChange(this.builtQuery[index].field);

      // Set SearchFields
      //this.selectedLayer = this.builtQuery[index].layer;  
      this.selectedLayer = this.dropdownLayerList.find((lyr) => lyr.value === this.builtQuery[index].layer) as ILayerDropdownListItem;
      this.selectedFieldName = this.builtQuery[index].field;

      if (this.enableDateTimePicker) {
        this.codedvalue = new Date(this.builtQuery[index].value);
      } else {
        this.codedvalue = this.builtQuery[index].value;
      }

      this.operator = this.builtQuery[index].operator;
      this.joinType = this.builtQuery[index].joinType;
    } catch (error) {
      console.error(error);
    }
  }

  emptySearchFields() {
    this.joinType = "";
    this.selectedLayer = null;
    this.codedvalue = "";
    this.operator = "";
    this.selectedFieldName = "";
  }

  deleteFieldValue(i) {
    if (this.builtQuery.length > 1 && i === 0) {
      Swal.fire("Cannot delete primary Query");
      return;
    }

    this.builtQuery.splice(i, 1);

    if (this.builtQuery.length === 0) {
      /** Default values in Search Fields */
      this.emptySearchFields();
      /** Join type should be null */
      this.queryStatement.joinType = null;
      /** Saved Query Filename text box empty */
      this.fileName = "";
      /** Reload all Saved Queries */
      this.savedQueriesList = this.getSavedQueries("PQ-A");
      this.savedQueriesList.concat(this.getSavedQueries("PQ"));
      /* Empty Fields and Values*/
      this.field = [];
      this.codedValues = [];
      // Cannot edit Hide Button
      this.isRowClicked = false;
      this.showRecordCount = false;
      this.queryDescription = "";
      // Clear Prev Selected for Query Behavior
      
      /** Reload Layers */
      this.dropdownLayerList = this.qbService.getLayerListDropdownValues();
      this.layr = this.dropdownLayerList.find((l) => l.value === this.selectedLayer?.value) as ILayerDropdownListItem;
      this.layr?.lyrObj.fields.forEach((f) => {
        this.field.push({
          Field: f.name,
          FieldAlias: f.alias
        });
      });
      this.selectedLayer = this.dropdownLayerList[0];

      this.selectedFieldName = this.field[0].Field;
      this.onFieldChange(this.selectedFieldName);
    } else if (this.builtQuery.length >= 1) {
      //this.qbService.disableLayerDropdown(this.qbService.getLayerInfo(this.queryStatement.layer), "");
      this.dropdownLayerList = this.qbService.getLayerListDropdownValues(this.builtQuery[0].layer);
    } else {
      this.dropdownLayerList = this.qbService.getLayerListDropdownValues();
    }
  }
  cleartable() {
    try {
      //this.layerList = this.qbService.getLayerInfo();
      this.dropdownLayerList = this.qbService.getLayerListDropdownValues();
      this.emptySearchFields();
      this.builtQuery = [];
      this.selectionGraphicsLyr = this.esriMapTool.map.getLayer("sms-selection");

      if (this.selectionGraphicsLyr) {
        this.selectionGraphicsLyr.clear();
      }

      this.esriMapTool.map.graphics.clear();
      this.queryDataObj = [];
      this.data.emit([]);
      this.fileName = "";
      this.selectedLoadFile = "";
      this.isRowClicked = false;
      this.showRecordCount = false;
      this.queryDescription = "";
    } catch (error) {
      console.error(error);
    }
  }

  editItem() {
    try {
      this.queryStatement = {} as IQueryStatement;

      this.queryStatement.layer = this.selectedLayer!.value;
      this.queryStatement.field = this.selectedFieldName;

      if (this.enableDateTimePicker) {
        const formattedDate = this.codedvalue.getMonth() + 1 + "-" + this.codedvalue.getDate() + "-" + this.codedvalue.getFullYear();
        this.queryStatement.value = formattedDate;
      } else {
        if (this.selectedFieldName === "AssetCode") {
          this.qbService.assetCode = this.codedValues;
        }

        this.queryStatement.value = this.codedvalue;
      }

      this.queryStatement.operator = this.operator;

      if (this.queryStatement.layer && this.queryStatement.field && this.queryStatement.operator && this.queryStatement.value) {
        if (this.index === 0) {
          if (this.queryStatement.joinType) {
            this.joinType = null;
            Swal.fire("Cannot edit Join type for primary Query");
            return;
          }

          this.queryStatement.joinType = undefined;
        } else {
          this.queryStatement.joinType = this.joinType;
        }

        this.builtQuery[this.index] = this.queryStatement;
        this.isRowClicked = false;
      } else {
        Swal.fire("Enter all Values");
      }
    } catch (error) {
      console.error(error);
    }
  }
  buildQuery() {
    try {
      this.loading = true;
      this.multipleResults = false;

      if (this.multiplePrimaryLayerQuery && this.multiplePrimaryLayerQuery.queryId && (this.multiplePrimaryLayerQuery.queryId === "QRY_10" || this.multiplePrimaryLayerQuery.queryId === "QRY_11")) {
        // this.buildQueryMultiple();
        return;
      }

      // Set Service Variables
      this.selectionGraphicsLyr = this.esriMapTool.map.getLayer("sms-selection");

      if (this.selectionGraphicsLyr) {
        this.selectionGraphicsLyr.clear();
      }

      // Set Resutts Object to empty : Refresh results object for new Query
      this.queryDataObj = [];
      // Hide Card View if already opened
      this.data.emit(this.queryDataObj);
      this.objectIds = [];

      if (this.builtQuery.length === 0) {
        Swal.fire("Please add a query to execute");
        this.loading = false;
        return;
      } else if (this.builtQuery.length === 1 && this.builtQuery[0].joinType != "") {
        this.joinType = null;
        Swal.fire("Query cannot start with a jointype");
        this.loading = false;
        return;
      }

      if (this.builtQuery[0].joinType != "") {
        this.joinType = null;
        Swal.fire("Query cannot start with a jointype");
        this.loading = false;
        return;
      }

      this.loading = true;
      const queryString = this.qbService.createQueryString(this.builtQuery, this.currentUser);
      const functionname = "test";
      this.genericLayerService.getQueryResults(queryString, functionname).subscribe(
        function (results: any) {
          if (results && results.table && results.table.length > 0) {
            results.table.forEach((v) => {
              this.objectIds.push(v.objectid);
            });
          }

          if (this.objectIds.length === 0) {
            Swal.fire("No records found");
            this.loading = false;
            this.showRecordCount = false;
            return;
          }

          this.loading = false;

          if (this.builtQuery[0].layer === "Assessment" || this.builtQuery[0].layer === "Maintenance" || this.builtQuery[0].layer === "Activity") {
            this.multipleResults = true;
            this.buildQueryMultiple();
            return;
          }

          this.loading = false;
          this.showRecordCount = true;
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }
  buildQueryMultiple() {
    try {
      this.multipleResults = true;
      this.loading = true;
      // Set Resutts Object to empty : Refresh results object for new Query
      this.queryDataObj = [];

      if (this.builtQuery.length === 0) {
        Swal.fire("Please add a query to execute");
        return;
      } else if (this.builtQuery.length === 1 && this.builtQuery[0].joinType != "") {
        this.builtQuery[0].joinType = "";
        Swal.fire("Query cannot start with a jointype");
      } else {
        // Get QueryString to fetch Data
        const queryString = this.qbService.createQueryString(this.builtQuery, this.currentUser);
        const functionname = "test";
        this.genericLayerService.getQueryResults(queryString, functionname).subscribe((results: any) => {
          console.log(results);

          if (results.table.length === 0) {
            this.showRecordCount = false;
            this.loading = false;
            Swal.fire("No recourds Found");
            return;
          }

          this.showRecordCount = true;
          this.loading = false;
          const allResults = [];

          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < results.table.length; i++) {
            allResults.push({
              layerName: results.table[i].layerName,
              dataLength: results.table[i].objectid.split(",").length
            });
          }

          this.multipleResultCounts = allResults;
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  saveQuery(queryTool) {
    try {
      queryTool = this.queryAssigned;

      if (this.queryDescription == null || this.queryDescription === "") {
        Swal.fire("Please enter Query Description before saving");
        return;
      }

      if (this.fileName == null || this.fileName === "") {
        Swal.fire("Please enter Query Name before saving");
        return;
      }

      /*Validate if file Name already present*/
      const validateFileName = this.savedQueriesList.filter((savedQuery) => savedQuery.fileName === this.fileName);

      if (this.builtQuery.length === 0) {
        Swal.fire("Add the query before Saving");
        return;
      }

      const queryString = this.qbService.createQueryString(this.builtQuery, this.currentUser);

      if (validateFileName.length > 0) {
        Swal.fire("Query Name cannot be duplicate");
        return;
      }

      this.qbService.saveQuery(this.fileName, this.esriMapTool.FeatureLayer, queryString, this.esriMapTool.Graphic, queryTool, this.queryDescription).then(
        function (result) {
          this.savedQueriesList = this.getSavedQueries("PQ");
          this.savedQueriesList.concat(this.getSavedQueries("PQ-A"));
          Swal.fire("Query Saved to the database");
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }
  assignToUser(event) {
    try {
      if (event.target.checked === true) {
        this.queryAssigned = "PQ-A";
      } else {
        this.queryAssigned = "PQ";
      }

      if (this.fileName) {
        this.updateQuery(this.queryAssigned, this.fileName);
      } else {
        Swal.fire("Please select a query To assign");
      }
    } catch (error) {
      console.error(error);
    }
  }
  updateQuery(queryAssigned, fileName) {
    try {
      const query = this.esriMapTool.Query();
      const layerobj = new this.esriMapTool.FeatureLayer(this.adminGlobalobj.agencyDetails[0].webServiceUrl + environment.featureServer + this.adminGlobalobj.serviceLyrInfo.userQueryActionsId);
      const queryTask = this.esriMapTool.QueryTask(layerobj.url);
      query.where = "QueryName = '" + fileName + "'";
      query.outFields = ["OBJECTID", "QueryTool"];
      queryTask.execute(
        query,
        function (result) {
          console.log(result);
          result.features[0].attributes.QueryTool = queryAssigned;
          layerobj.applyEdits(null, [result.features[0]], null);
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  deleteQuery(queryTool:string) {
    try {
      if (this.fileName == null || this.fileName === "") {
        Swal.fire("Enter a Query Name to delete");
        return;
      }

      const checkFilePresent = this.savedQueriesList.filter((list) => list.fileName === this.fileName);

      if (checkFilePresent.length <= 0) {
        Swal.fire("Entered Query Name not available in database");
        return;
      }

      const userActionsQueryLayer = this.adminGlobalobj.agencyDetails[0].webServiceUrl + environment.featureServer + this.adminGlobalobj.serviceLyrInfo.userQueryActionsId;
      const userActionsQueryLayerObj = new this.esriMapTool.FeatureLayer(userActionsQueryLayer);
      const promise = this.qbService.deleteQuery(this.esriMapTool.FeatureLayer, this.fileName, this.esriMapTool.Query, this.esriMapTool.QueryTask, queryTool);
      let deleteRecord;
      promise.then(
        function (result) {
          if (result) {
            deleteRecord = result;

            if (deleteRecord.length === 0) {
              Swal.fire("No Such Query Name available");
              return;
            }
            this.queryLayersService.deleteAsset(userActionsQueryLayerObj, deleteRecord.features[0]).then(
              function (result) {
                if (result) {
                  Swal.fire("Successfully Deleted");
                  this.savedQueriesList = this.getSavedQueries("PQ");
                  this.savedQueriesList.concat(this.getSavedQueries("PQ-A"));
                  this.builtQuery = [];
                  this.fileName = "";
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }
}
